import { GenericToastrService } from './../generic-components/generic-toastr/generic-toastr.service';
import { Component, OnInit } from '@angular/core';
import { MainComponent } from '../main/main.component';
import { Correspondance } from '../models/Correspondance';
import { TableConfig } from '../generic-components/generic-table/class/TableConfig';
import { PageInformations } from '../generic-components/generic-table/class/PageInformations';
import { CorrespondanceService } from './correspondance.service';
import { GenericSearchService } from '../generic-components/generic-search/generic-search.service';
import { GenericTableComponent } from '../generic-components/generic-table/generic-table.component';
import { PageEvent } from '@angular/material/paginator';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { GenericCreateButtonComponent } from '../generic-components/generic-create-button/generic-create-button.component';
import { MatDialog } from '@angular/material/dialog';
import { CreateCorrespondanceComponent } from './create-correspondance/create-correspondance.component';
import { GenericSearchLabelComponent } from '../generic-components/generic-search-label/generic-search-label.component';
import { GenericValidateComponent } from '../generic-components/generic-validate/generic-validate.component';

@Component({
  selector: 'app-correspondance',
  imports: [
    MainComponent,
    GenericTableComponent,
    NgxSpinnerComponent,
    GenericCreateButtonComponent,
    GenericSearchLabelComponent,
  ],
  templateUrl: './correspondance.component.html',
  styleUrl: './correspondance.component.css',
})
export class CorrespondanceComponent implements OnInit {
  listCorrespondance: Correspondance[] = [];

  pageInformations: PageInformations = new PageInformations();

  emitClickRow = 'update';

  tableConfig: TableConfig = {
    columns: [
      {
        id: 'codeDivalto',
        libelle: 'Code divalto',
        property: 'codeDivalto',
        researchable: true,
      },
      {
        id: 'libelleDivalto',
        libelle: 'Libelle divalto',
        property: 'libelleDivalto',
        researchable: true,
      },
      {
        id: 'libelleRg',
        libelle: 'Libelle RG',
        property: 'libelleRg',
        researchable: false,
      },
      {
        id: 'libelleBit',
        libelle: 'Libelle BIT',
        property: 'libelleBit',
        researchable: false,
      },
      {
        id: 'options',
        libelle: 'Options',
        property: 'options',
        researchable: false,
      },
    ],
  };

  constructor(
    private correspondanceService: CorrespondanceService,
    private searchService: GenericSearchService,
    private spinner: NgxSpinnerService,
    private toastrService: GenericToastrService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loadCorrespondances();
  }

  pageEvent(event: PageEvent) {
    this.pageInformations.pageIndex = event.pageIndex;
    this.pageInformations.pageSize = event.pageSize;
    this.loadCorrespondances();
  }

  loadCorrespondances(query?: string): void {
    this.spinner.show();

    if (query == null) {
      query = 'id>0';
    }
    this.searchService
      .search(
        'correspondance',
        query,
        this.pageInformations.pageIndex,
        this.pageInformations.size,
        'codeDivalto=asc'
      )
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          this.listCorrespondance = res.content;
          this.pageInformations = this.searchService.updatePageInformations(
            this.pageInformations,
            res
          );
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  createButtonClicked() {
    const dialogRef = this.dialog.open(CreateCorrespondanceComponent, {
      disableClose: true,
      width: '50%',
      backdropClass: 'blurred-backdrop',
    });

    dialogRef.componentInstance.createCorrespondanceEmit.subscribe((event) => {
      this.spinner.show();
      this.correspondanceService.createCorrespondance(event).subscribe(
        (result) => {
          this.toastrService.openSnackBarSuccess(
            'Correspondance créée avec succés'
          );
          this.loadCorrespondances();
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          this.toastrService.openSnackBarProblem(error.error.message);
        }
      );
    });
  }

  updateCorrespondance(correspondance: Correspondance) {
    const dialogRef = this.dialog.open(CreateCorrespondanceComponent, {
      disableClose: true,
      width: '50%',
      backdropClass: 'blurred-backdrop',
      data: {
        correspondance: correspondance,
        searchService: this.searchService,
      },
    });

    dialogRef.componentInstance.updateCorrespondanceEmit.subscribe((event) => {
      this.spinner.show();
      this.correspondanceService.updateCorrespondance(event).subscribe(
        (result) => {
          this.loadCorrespondances();
          this.spinner.hide();

          this.toastrService.openSnackBarSuccess(
            'Correspondance modifiée avec succés'
          );
        },
        (error) => {
          this.spinner.hide();

          this.toastrService.openSnackBarProblem(error.error.message);
        }
      );
    });
  }

  deleteCorrespondance(correspondance: Correspondance) {
    const dialogRef = this.dialog.open(GenericValidateComponent, {
      data: {
        libelle: 'Voulez-vous vraiment supprimer cette correspondance ?',
      },
      width: '50%',
      backdropClass: 'blurred-backdrop',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.spinner.show();
        this.correspondanceService
          .deleteCorrespondance(correspondance)
          .subscribe(
            (result) => {
              this.loadCorrespondances();
              this.spinner.hide();
              this.toastrService.openSnackBarSuccess(
                'Correspondance supprimé avec succés !'
              );
            },
            (error) => {
              this.spinner.hide();
              this.toastrService.openSnackBarProblem(error.error.message);
            }
          );
      }
    });
  }
}
